import Grid2 from "@mui/material/Unstable_Grid2";
import Table from "../../../components/table/Table";
import GlobalMarketTopPriceChangesForm from "./GlobalMarketTopPriceChangesForm";
import { faCols_globalMarketTopPriceChanges } from "../../../components/tableHeaderNames/HeaderName";
import { useGlobalMarketTopPriceChangesContext } from "../../../context/global-market/GlobalMarketTopPriceChangesContext";
import MarketChart from "../../market-watch/MarketChart";

const GlobalMarketTopPriceChanges = () => {
  const { tableData } = useGlobalMarketTopPriceChangesContext();
  return (
    <Grid2 container>
      <Grid2 xs={12}>
        <Table
          tableData={tableData}
          isActions={true}
          Chart={MarketChart}
          height="88vh"
          faCols={faCols_globalMarketTopPriceChanges}
          tableTitle={{
            title: "بیشترین تغییرات قیمتی کالا",
            desc: "متن آزمایشی",
          }}
          Form={GlobalMarketTopPriceChangesForm}
        />
      </Grid2>
    </Grid2>
  );
};

export default GlobalMarketTopPriceChanges;
